const WEBVIEW_USER_AGENT_PATTERN = /wv|WebView/;
const IOS_WEBVIEW_USER_AGENT_PATTERN =
  /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/;

export const isWebView = () => {
  const windowWithOpera = window as Window & { opera?: string };
  const userAgent =
    window.navigator.userAgent ||
    window.navigator.vendor ||
    windowWithOpera.opera ||
    '';

  return (
    WEBVIEW_USER_AGENT_PATTERN.test(userAgent) ||
    IOS_WEBVIEW_USER_AGENT_PATTERN.test(userAgent)
  );
};
